import { Platform, useWindowDimensions } from 'react-native';

import { WEB_DESKTOP_BREAKPOINT } from 'styles/constants/breakpoints';

/** Native tablets keep the phone layout, matching the app's legacy breakpoint policy. */
export const useIsDesktopWebBreakpoint = (): boolean => {
  const { width } = useWindowDimensions();
  return Platform.OS === 'web' && width >= WEB_DESKTOP_BREAKPOINT;
};
